export const categories = [
  {
    slug: 'getting-started',
    name: '入门指南',
    description: '从零开始了解17c，快速上手核心功能',
    icon: 'ri-rocket-line',
    color: 'accent',
    articleCount: 12,
  },
  {
    slug: 'features',
    name: '功能详解',
    description: '深入探索17c各项强大功能的用法与技巧',
    icon: 'ri-apps-2-line',
    color: 'primary',
    articleCount: 18,
  },
  {
    slug: 'tutorials',
    name: '使用教程',
    description: '手把手教学视频与图文教程，轻松掌握17c',
    icon: 'ri-play-circle-line',
    color: 'secondary',
    articleCount: 15,
  },
  {
    slug: 'updates',
    name: '版本更新',
    description: '第一时间了解17c最新版本的变化与改进',
    icon: 'ri-refresh-line',
    color: 'accent',
    articleCount: 8,
  },
  {
    slug: 'best-practices',
    name: '最佳实践',
    description: '行业专家分享的17c高效使用技巧与案例',
    icon: 'ri-star-line',
    color: 'primary',
    articleCount: 10,
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '汇集用户最关心的17c使用疑问与解答',
    icon: 'ri-question-line',
    color: 'secondary',
    articleCount: 20,
  },
];

export const allArticles = [
  {
    id: 'article-1',
    slug: 'what-is-17c',
    title: '什么是17c？全面了解这个核心体验平台',
    excerpt: '17c是一个集成了多种功能的综合性体验平台，无论您是个人用户还是企业团队，都能在17c找到适合您需求的解决方案。本文将为您全面介绍17c的核心定位和价值主张。',
    content: `<h2>17c平台概述</h2>
      <p>17c诞生于对数字化体验的深刻理解之上。我们注意到，在当今快节奏的数字世界中，用户需要一个能够整合多种功能、提供一致体验的平台。17c正是基于这一洞察而创建的。</p>
      <h2>核心定位</h2>
      <p>17c定位为"一站式数字体验中心"，它将内容管理、数据分析、用户交互等多个维度的功能整合在一个统一界面中。无论您是需要管理内容、分析数据还是与用户互动，17c都能为您提供流畅的体验。</p>
      <h2>平台架构</h2>
      <p>17c采用先进的微服务架构，确保了平台的稳定性与可扩展性。每个功能模块独立运行，既保证了性能，又便于后续的功能扩展和升级。</p>
      <h2>适用人群</h2>
      <p>17c面向广泛的用户群体，包括内容创作者、企业管理者、数据分析师以及普通用户。不同角色的用户都能在17c找到适合自己的工作流程。</p>
      <h2>价值主张</h2>
      <p>使用17c，您将获得：统一的数字工作台、高效的内容管理工具、直观的数据分析仪表盘，以及持续的版本更新和技术支持。</p>`,
    category: 'getting-started',
    categoryName: '入门指南',
    author: '17c官方团队',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20interface%20with%20clean%20minimalist%20dashboard%20design%2C%20warm%20lighting%2C%20abstract%20geometric%20shapes%20in%20amber%20and%20teal%20colors%2C%20soft%20gradient%20background%2C%20product%20hero%20shot%2C%20professional%20photography%20style%20with%20diffused%20lighting&width=800&height=450&seq=article-17c-intro&orientation=landscape',
    tags: ['17c', '平台介绍', '入门'],
    featured: true,
  },
  {
    id: 'article-2',
    slug: '17c-quick-start-guide',
    title: '17c快速上手指南：十分钟掌握核心操作',
    excerpt: '刚接触17c？不用担心！本指南将带您在十分钟内完成从注册到熟练使用核心功能的全部流程，让您快速融入17c生态。',
    content: `<h2>注册与登录</h2>
      <p>访问17c官网，点击右上角的"注册"按钮，填写基本信息即可完成注册。17c支持邮箱注册和手机号注册两种方式。</p>
      <h2>界面导览</h2>
      <p>登录后，您将看到17c的主控制台。左侧为导航栏，包含所有功能模块的入口；中央为工作区，是您进行主要操作的地方；右侧为辅助面板，提供快捷操作和相关信息。</p>
      <h2>核心功能体验</h2>
      <p>17c的核心功能包括内容管理、数据分析、团队协作等。我们建议新用户先体验内容管理模块，这是17c最基础也最强大的功能。</p>
      <h2>个性化设置</h2>
      <p>在设置中心，您可以调整界面主题、通知偏好、语言选项等。17c提供了丰富的个性化选项，让您打造专属的工作环境。</p>`,
    category: 'getting-started',
    categoryName: '入门指南',
    author: '17c官方团队',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=step%20by%20step%20tutorial%20interface%20showing%20onboarding%20process%2C%20clean%20minimal%20design%2C%20warm%20amber%20and%20cream%20color%20scheme%2C%20soft%20diffused%20lighting%2C%20modern%20UI%20screenshot%20style%2C%20professional%20product%20photography&width=800&height=450&seq=article-quickstart&orientation=landscape',
    tags: ['17c', '入门教程', '快速上手'],
    featured: true,
  },
  {
    id: 'article-3',
    slug: '17c-advanced-features-overview',
    title: '17c高级功能详解：解锁平台全部潜力',
    excerpt: '17c不仅提供基础功能，还内置了大量高级特性。本文详细解析数据分析、自动化工作流、API集成等高级功能的用法。',
    content: `<h2>数据分析模块</h2>
      <p>17c的数据分析模块提供了丰富的数据可视化工具。您可以创建自定义仪表盘，实时监控关键指标，并生成详细的报表。</p>
      <h2>自动化工作流</h2>
      <p>17c的工作流引擎支持创建复杂的自动化流程。通过拖拽式界面，您可以轻松配置触发条件和执行动作，大幅提升工作效率。</p>
      <h2>API与集成</h2>
      <p>17c提供了完善的REST API和Webhook支持，可以无缝对接您现有的技术栈。无论是CRM系统、邮件服务还是第三方工具，都能轻松集成。</p>
      <h2>团队协作</h2>
      <p>17c的团队空间功能支持多人实时协作，包括文档共享、任务分配、评论讨论等，让团队协作更加流畅高效。</p>`,
    category: 'features',
    categoryName: '功能详解',
    author: '17c技术团队',
    publishDate: '2026-07-22',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20analytics%20dashboard%20with%20charts%20and%20graphs%2C%20modern%20data%20visualization%2C%20warm%20teal%20and%20cream%20color%20palette%2C%20clean%20minimalist%20design%2C%20professional%20software%20interface%2C%20soft%20ambient%20lighting&width=800&height=450&seq=article-advanced&orientation=landscape',
    tags: ['17c', '高级功能', '数据分析'],
    featured: true,
  },
  {
    id: 'article-4',
    slug: '17c-content-management-tutorial',
    title: '17c内容管理完全教程：从创建到发布',
    excerpt: '内容管理是17c的核心功能之一。本教程将详细讲解如何在17c中创建、编辑、管理和发布内容，包含大量实用技巧。',
    content: `<h2>内容创建</h2>
      <p>17c提供了强大的富文本编辑器，支持Markdown语法和所见即所得编辑模式。您可以插入图片、视频、表格等多媒体内容。</p>
      <h2>内容组织</h2>
      <p>通过17c的分类和标签系统，您可以轻松组织大量内容。支持多级分类、交叉标签和自定义排序规则。</p>
      <h2>版本管理</h2>
      <p>17c自动保存内容的历史版本，您可以随时回溯和恢复之前的版本，再也不用担心误操作导致内容丢失。</p>
      <h2>发布流程</h2>
      <p>17c支持定时发布、审核流程和批量操作，让内容发布更加规范和高效。</p>`,
    category: 'tutorials',
    categoryName: '使用教程',
    author: '17c内容团队',
    publishDate: '2026-07-20',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Content%20management%20system%20interface%20with%20rich%20text%20editor%2C%20modern%20dashboard%20design%2C%20warm%20earth%20tone%20colors%2C%20clean%20minimal%20layout%2C%20soft%20natural%20lighting%2C%20professional%20UI%20screenshot&width=800&height=450&seq=article-content&orientation=landscape',
    tags: ['17c', '内容管理', '教程'],
    featured: false,
  },
  {
    id: 'article-5',
    slug: '17c-version-3-update',
    title: '17c v3.0 重磅更新：全新界面与性能飞跃',
    excerpt: '17c最新版本v3.0正式发布！本次更新带来了全新的用户界面设计、显著的性能提升以及多项用户期待已久的新功能。',
    content: `<h2>全新界面设计</h2>
      <p>v3.0版本对用户界面进行了全面重构，采用更现代的设计语言。新的界面更加简洁直观，操作流程更加顺畅，同时保留了对老用户的熟悉感。</p>
      <h2>性能提升</h2>
      <p>通过底层架构优化，v3.0的页面加载速度提升了40%，数据处理效率提高了60%。即使在处理大量数据时，17c依然保持流畅的响应。</p>
      <h2>新增功能</h2>
      <p>本次更新新增了智能搜索、批量操作面板、自定义主题、暗黑模式等功能，让您的使用体验更上一层楼。</p>
      <h2>升级指南</h2>
      <p>现有用户可以在设置中检查更新并一键升级到最新版本。升级过程不会影响您的数据和工作流程。</p>`,
    category: 'updates',
    categoryName: '版本更新',
    author: '17c开发团队',
    publishDate: '2026-07-18',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20software%20version%20update%20announcement%20with%20new%20features%20showcase%2C%20clean%20minimal%20design%2C%20warm%20amber%20and%20teal%20accent%20colors%2C%20soft%20gradient%20background%2C%20professional%20product%20marketing%20visual&width=800&height=450&seq=article-update&orientation=landscape',
    tags: ['17c', '版本更新', 'v3.0'],
    featured: false,
  },
  {
    id: 'article-6',
    slug: '17c-best-practices-enterprise',
    title: '17c企业级最佳实践：大型团队如何高效协作',
    excerpt: '了解企业如何在17c平台上实现高效的团队协作和项目管理。本文分享来自一线企业的真实实践经验和优化建议。',
    content: `<h2>团队架构设计</h2>
      <p>在17c中，合理的团队架构是高效协作的基础。建议按照业务线或项目维度创建团队空间，每个空间配置独立的权限和资源。</p>
      <h2>工作流程规范</h2>
      <p>制定清晰的工作流程是提升团队效率的关键。利用17c的自动化工作流，将重复性任务自动化，让团队成员专注于创造性工作。</p>
      <h2>数据安全策略</h2>
      <p>企业级用户需要特别关注数据安全。17c提供了细粒度的权限管理、操作审计日志和数据加密功能，确保企业数据安全无虞。</p>`,
    category: 'best-practices',
    categoryName: '最佳实践',
    author: '17c企业服务团队',
    publishDate: '2026-07-15',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Enterprise%20team%20collaboration%20workspace%20with%20modern%20office%20setup%2C%20multiple%20screens%20showing%20dashboards%2C%20warm%20professional%20lighting%2C%20clean%20aesthetic%2C%20amber%20and%20cream%20tone%20color%20palette&width=800&height=450&seq=article-enterprise&orientation=landscape',
    tags: ['17c', '最佳实践', '企业协作'],
    featured: false,
  },
  {
    id: 'article-7',
    slug: '17c-data-analysis-guide',
    title: '用17c进行数据分析：从入门到精通',
    excerpt: '17c内置了强大的数据分析工具。本指南将教您如何利用17c的分析功能洞察数据价值，做出更明智的决策。',
    content: `<h2>数据导入</h2>
      <p>17c支持多种数据源接入，包括CSV文件导入、API数据拉取和数据库直连。数据导入过程简单直观，支持自动识别数据格式。</p>
      <h2>可视化配置</h2>
      <p>17c提供了20多种图表类型，从基础的柱状图、折线图到高级的热力图、漏斗图，满足不同场景的数据展示需求。</p>
      <h2>报表生成</h2>
      <p>您可以创建自定义报表模板，设置定期自动生成和发送。报表支持导出为PDF、Excel等多种格式。</p>`,
    category: 'features',
    categoryName: '功能详解',
    author: '17c数据团队',
    publishDate: '2026-07-12',
    readTime: '11分钟',
    image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20on%20screen%2C%20modern%20minimal%20design%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20soft%20lighting%2C%20professional%20business%20analytics%20visual&width=800&height=450&seq=article-data&orientation=landscape',
    tags: ['17c', '数据分析', '可视化'],
    featured: false,
  },
  {
    id: 'article-8',
    slug: '17c-mobile-experience',
    title: '17c移动端体验：随时随地高效工作',
    excerpt: '17c移动端应用全面升级，提供与桌面端一致的强大功能。了解如何在移动设备上充分利用17c的全部能力。',
    content: `<h2>移动端界面</h2>
      <p>17c移动端采用了专为触屏优化的界面设计，在保持核心功能完整的同时，确保在小屏幕上的操作体验同样流畅。</p><h2>离线模式</h2><p>17c移动端支持离线模式，即使没有网络连接，您也可以查看已缓存的内容和数据。网络恢复后，所有更改会自动同步。</p>`,
    category: 'tutorials',
    categoryName: '使用教程',
    author: '17c产品团队',
    publishDate: '2026-07-10',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Mobile%20app%20interface%20on%20smartphone%20showing%20modern%20dashboard%2C%20clean%20minimal%20design%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20natural%20lighting%2C%20product%20photography%20style&width=800&height=450&seq=article-mobile&orientation=landscape',
    tags: ['17c', '移动端', '使用技巧'],
    featured: false,
  },
  {
    id: 'article-9',
    slug: '17c-security-features',
    title: '17c安全保障体系：您的数据由我们守护',
    excerpt: '安全性是17c平台的重中之重。本文详细介绍17c的多层安全防护体系，包括数据加密、访问控制和合规认证。',
    content: `<h2>数据加密</h2>
      <p>17c采用AES-256加密标准对静态数据进行加密，传输过程使用TLS 1.3协议保护。所有用户数据都经过严格的加密处理。</p>
      <h2>访问控制</h2>
      <p>支持基于角色的访问控制(RBAC)、双因素认证(2FA)和单点登录(SSO)，确保只有授权人员能够访问敏感数据和功能。</p>
      <h2>合规认证</h2>
      <p>17c已通过ISO 27001信息安全管理体系认证，并符合GDPR等国际数据保护法规的要求。</p>`,
    category: 'features',
    categoryName: '功能详解',
    author: '17c安全团队',
    publishDate: '2026-07-08',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20concept%20with%20shield%20and%20lock%20icons%2C%20modern%20minimal%20design%2C%20warm%20teal%20and%20cream%20color%20scheme%2C%20digital%20security%20visualization%2C%20soft%20ambient%20lighting&width=800&height=450&seq=article-security&orientation=landscape',
    tags: ['17c', '安全', '数据保护'],
    featured: false,
  },
  {
    id: 'article-10',
    slug: '17c-integration-ecosystem',
    title: '17c集成生态：连接您喜爱的所有工具',
    excerpt: '17c拥有丰富的第三方集成生态。本文汇总了17c支持的各类集成方案，帮助您打造无缝的工作流体验。',
    content: `<h2>集成概览</h2>
      <p>17c目前已支持超过50款主流工具的集成，涵盖项目管理、即时通讯、代码托管、设计协作等多个领域。</p>
      <h2>热门集成</h2>
      <p>最受欢迎的集成包括Slack通知推送、GitHub代码关联、Figma设计同步、Google Calendar日程管理等。</p>
      <h2>自定义集成</h2>
      <p>如果官方集成列表中没有您需要的工具，17c的开放API和Webhook机制允许您自行构建定制化的集成方案。</p>`,
    category: 'best-practices',
    categoryName: '最佳实践',
    author: '17c生态团队',
    publishDate: '2026-07-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Connected%20app%20icons%20and%20integration%20ecosystem%20visualization%2C%20modern%20network%20design%2C%20warm%20amber%20and%20cream%20colors%2C%20clean%20minimal%20layout%2C%20soft%20lighting%2C%20tech%20ecosystem%20concept&width=800&height=450&seq=article-integration&orientation=landscape',
    tags: ['17c', '集成', '生态'],
    featured: false,
  },
  {
    id: 'article-11',
    slug: '17c-faq-account',
    title: '17c账户相关常见问题汇总',
    excerpt: '关于17c账户注册、登录、密码找回、账户安全等常见问题的官方解答，帮您快速解决账户相关问题。',
    content: `<h2>如何注册17c账户？</h2>
      <p>访问17c官网，点击"注册"按钮，输入您的邮箱地址并设置密码即可完成注册。您也可以使用第三方账号快速注册。</p>
      <h2>忘记密码怎么办？</h2>
      <p>在登录页面点击"忘记密码"，输入注册邮箱，系统会发送密码重置链接到您的邮箱。</p>
      <h2>如何修改绑定手机号？</h2>
      <p>登录后在"账户设置-安全设置"中可以修改绑定的手机号，需要进行身份验证。</p>`,
    category: 'faq',
    categoryName: '常见问题',
    author: '17c客服团队',
    publishDate: '2026-07-02',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Frequently%20asked%20questions%20concept%20with%20help%20icon%2C%20modern%20minimal%20design%2C%20warm%20amber%20and%20cream%20color%20scheme%2C%20customer%20support%20visualization%2C%20soft%20lighting&width=800&height=450&seq=article-faq&orientation=landscape',
    tags: ['17c', 'FAQ', '账户'],
    featured: false,
  },
  {
    id: 'article-12',
    slug: '17c-performance-optimization',
    title: '17c性能优化指南：让平台运行如飞',
    excerpt: '通过简单的设置和优化技巧，让您的17c平台运行速度更快、响应更灵敏。本指南涵盖从基础到高级的优化方法。',
    content: `<h2>浏览器优化</h2>
      <p>使用最新版本的Chrome、Edge或Firefox浏览器访问17c可获得最佳体验。建议开启硬件加速功能。</p>
      <h2>网络优化</h2>
      <p>17c在全球部署了CDN加速节点，大多数地区用户都能获得低延迟的访问体验。建议使用稳定的网络连接。</p>
      <h2>数据优化</h2>
      <p>定期清理不需要的数据和缓存文件，合理使用17c的数据归档功能，保持平台数据整洁高效。</p>`,
    category: 'tutorials',
    categoryName: '使用教程',
    author: '17c技术团队',
    publishDate: '2026-06-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Speed%20and%20performance%20optimization%20concept%20with%20racing%20metaphor%2C%20modern%20minimal%20design%2C%20warm%20amber%20and%20teal%20colors%2C%20clean%20aesthetic%2C%20soft%20natural%20lighting&width=800&height=450&seq=article-perf&orientation=landscape',
    tags: ['17c', '性能优化', '技巧'],
    featured: false,
  },
];

export const features = [
  {
    icon: 'ri-dashboard-line',
    title: '智能仪表盘',
    description: '一站式数据总览，关键指标一目了然，支持自定义布局和实时数据刷新。',
  },
  {
    icon: 'ri-file-text-line',
    title: '内容管理',
    description: '强大的富文本编辑器与媒体库，支持多格式内容创建、版本管理与协作编辑。',
  },
  {
    icon: 'ri-bar-chart-line',
    title: '数据分析',
    description: '内置20+图表类型与智能分析引擎，帮助您从数据中挖掘有价值的洞察。',
  },
  {
    icon: 'ri-team-line',
    title: '团队协作',
    description: '实时多人协作、任务分配、评论讨论，让团队沟通和项目推进更加高效。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全保障',
    description: '多层安全防护体系，AES-256加密、RBAC权限管理，全方位保护您的数据。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '桌面端与移动端无缝切换，离线模式支持，随时随地保持高效工作状态。',
  },
];

export const faqs = [
  {
    question: '17c是什么？',
    answer: '17c是一个综合性的数字体验平台，集成了内容管理、数据分析、团队协作等多种功能，帮助个人和团队提升工作效率。',
  },
  {
    question: '17c支持哪些设备？',
    answer: '17c支持Windows、macOS、Linux桌面端，以及iOS和Android移动端。您可以在任意设备上通过浏览器访问17c的全部功能。',
  },
  {
    question: '如何开始使用17c？',
    answer: '访问17c官网注册账号即可免费开始使用。我们提供完整的入门指南和视频教程，帮助您快速上手。',
  },
  {
    question: '17c有免费版本吗？',
    answer: '是的，17c提供功能丰富的免费版本，适合个人用户和小型团队使用。如需更多高级功能，可以升级到专业版或企业版。',
  },
  {
    question: '17c的数据安全如何保障？',
    answer: '17c采用AES-256数据加密、TLS 1.3传输加密、RBAC权限管理和双因素认证等多层安全措施，并通过ISO 27001认证。',
  },
  {
    question: '如何联系17c技术支持？',
    answer: '您可以通过官网在线客服、邮件support@17c.com或帮助中心提交工单。企业版用户享有专属客户经理和优先技术支持。',
  },
];

export const stats = [
  { value: '500万+', label: '活跃用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '150+', label: '国家和地区' },
  { value: '50万+', label: '企业客户' },
];

export const testimonials = [
  {
    name: '张明',
    role: '产品总监',
    company: '星辰科技',
    content: '17c彻底改变了我们团队的工作方式。数据分析功能让我们能够快速做出数据驱动的决策，协作效率提升了至少50%。',
  },
  {
    name: '李薇',
    role: '运营主管',
    company: '未来互动',
    content: '使用17c后，我们的内容管理流程变得前所未有的顺畅。版本管理和审核流程让团队协作更加规范高效。',
  },
  {
    name: '王强',
    role: '技术负责人',
    company: '云端软件',
    content: '17c的API集成能力令人印象深刻，我们轻松地将内部系统与17c对接，打通了整个工作流程。安全性能也让我们非常放心。',
  },
];